import { Flex } from "antd";
import styled, { createGlobalStyle } from "styled-components";
import { Swiper } from "swiper/react";

import "swiper/swiper-bundle.css";

export const PageWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  gap: theme.spacing * 5,
  padding: theme.spacing * 2.5,
  maxWidth: theme.screenLGMax,
  margin: "0 auto",

  [`@media (max-width: ${theme.screenMDMax}px)`]: {
    flexDirection: "column",
  },
}));

export const ImagesCarouselWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  borderRadius: theme.borderRadius,
  overflow: "hidden",
  maxHeight: 400,
  aspectRatio: "16 / 9",

  [`@media (max-width: ${theme.screenMDMax}px)`]: {
    borderRadius: 0,
    marginInline: -theme.spacing * 2.5,
  },
}));

export const MainContentWrapper = styled("section")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing * 3,
  flex: 1,
}));

export const SideContentWrapper = styled("section")(({ theme }) => ({
  maxWidth: "30%",
  gap: 24,
  display: "flex",
  flexDirection: "column",
  width: "100%",

  [`@media (max-width: ${theme.screenMDMax}px)`]: {
    flexDirection: "column",
    maxWidth: "unset",
  },
}));

export const BusinessStaffMembersSwiper = styled(Swiper)({
  "& .swiper-slide": {
    maxWidth: 72,
  },
});

export const MapContainer = styled(Flex)(({ theme }) => ({
  height: 300,
  borderRadius: theme.borderRadius,
  overflow: "hidden",

  "& .ant-skeleton": {
    width: "100%",
    height: "100%",

    "& .ant-skeleton-image": {
      width: "100%",
      height: "100%",
    },
  },
}));

export const SwiperThemeOverride = createGlobalStyle`
  :root {
    --swiper-theme-color: white;
  }
`;
